import React from "react";
// { Suspense, lazy } 
import { Route, Router, IndexRoute, hashHistory } from 'react-router';
import ReactGA from 'react-ga';
import {
  ClaimsDashboard, CustomerStatusX, PolicyAdmin, PolicyAmendment, BulkPolicyOnboarding, FailedEnteries, ClaimProcessing, ClaimInitiation,
  BulkPayments, FailedPaymentsEnteries, HomePage, PolicyProcessing,
  KnowledgeBase,
  ViewGuide,
  elasticSearch,
  Death_Claims,
  Disability_Claims,
  Hospital_claims,
  Last_Expense_claims,
  property_claims,
  Reimbursement_claims,
  Device_Damage_Claims,
  Device_theft_Claims,
  Funeral_Claims,
  SimpleClaimProcessing,
  Critical_Illness_Claims,
  Cancer_Care_Claims,
  GeneratePolicy,
  Cover_Link_Medical_Cash_Claims,
  Cover_Link_Legal_Claims,
  Hospital_Cash_Accident_Claims,
  PoliciesDashboard,
  RecentPolicies,
  //GeneratePolicy
} from './components';
import { getAnanlyticsId } from '../lib/monitoring.es6';
// import Main from '../containers/Main/index.es6';


 import Main from '../containers/Main/index.es6'
 // Admin lazy loaded - don't import here
 import RegisterCustomer from '../containers/RegisterCustomer/index.es6'

 import PremiumList from '../containers/PremiumList/index.es6'
 import PaymentList from '../containers/PaymentList/index.es6'
 import ClaimList from '../containers/ClaimList/index.es6'
 import PolicyList from '../containers/PolicyList/index.es6'
 import BuyPolicy from '../containers/BuyPolicy/index.es6'
 import MakeClaim from '../containers/ClaimSubmission/index.es6'
 import Customer from '../containers/Customer/index.es6'
 import Profile from '../containers/Profile/index.es6'
 import Settings from '../containers/Settings/index.es6'
 import SalesManagerPolicies from '../containers/SalesManagerPolicies/index'
 import PolicyApprovalDashboard from '../containers/PolicyApprovalDashboard/index'
 import PremiumTransferDashboard from '../containers/PremiumTransferDashboard/index'
 import RecentPaymentsContainer from '../containers/RecentPayments/index'
 import PolicyOnboarding from '../containers/PolicyOnboarding/index'

 import ClaimsClosed from '../containers/ClaimsClosed/index.es6'
//  import ClaimsProcessing from '../containers/ClaimsProcessing/index.es6'
 import ClaimsPayable from '../containers/ClaimsPayable/index.es6'
 import ClaimsOpen from '../containers/ClaimsOpen/index.es6'
 import ClaimsStatus from '../containers/ClaimsStatus/index.es6'
 import ClaimCallback from '../containers/ClaimCallback/index.es6'
 import UsersNew from '../containers/UsersNew/UsersNew'
 import PartnerUsers from '../containers/PartnerUsers/index'
 import LoyaltyEligibility from '../containers/LoyaltyEligibility/index.es6'
 import Dashboards from '../containers/Dashboards/index.es6'

 import GenericProducts from "../containers/GenericProductConfig/ViewProducts/index.js";
 import ViewGenericProduct from "../containers/GenericProductConfig/ViewProduct/index.js";

 import InternalDashboards from '../containers/InternalDashboard/index.es6'
 import PageNotFound from '../containers/PageNotFound/index.es6'
 import BulkSms from '../containers/BulkSms/index.es6'
 import Partners from '../containers/Partners/index.es6'
 import NewProducts from '../containers/NewProductList/index.es6'
 import ViewProductStatus from '../containers/NewProductList/components/ViewProduct/index'
 import ManualPayment from '../containers/ManualPayment/index.es6'
 import SmsTemplate from '../containers/SmsTemplate/index.es6'
 import EngineFlows from '../containers/EngineFlows/index.es6'
 import TaxConfigs from '../containers/TaxConfigs/index.es6'
 import KYCConfigs from '../containers/KYCConfigs/index.es6'
 import AmlConfigs from '../containers/AmlConfigs/index.es6'
 import RiskConfigs from '../containers/RiskConfigs/index.es6'
 import IprsConfigs from '../containers/IprsConfigs/index.es6'
 import GatewayConfigs from '../containers/GatewayConfigs/index.es6'
 import WebhookSubscriptions from '../containers/WebhookSubscriptions/index.es6'

 import ManualRemittances from "../containers/ManualRemittance/index.es6"
 import Cashback from '../containers/Cashback/index.es6'
 import PartnerStatus from '../containers/PartnerStatus'
 import ViewLanguages from '../containers/Languages/ViewLanguages'
 import DependantsList from '../containers/DependantsList/index.es6'
 import ViewCountries from '../containers/Country/ViewCountries'
 import LandingPage from '../containers/Login/LandingPageRouter'
 // DrawerNew lazy loaded - see route below
 import ClaimDashboardv2 from '../containers/ClaimDashboardv2/index'
 import Alerts from '../components/AlertDialogNew/Alerts'
 import DocumentGeneration from "../containers/DocumentGeneration"


 import Hospitals from '../partner-apps/ktda/Hospitals/index'
 import Diagnosis from '../partner-apps/ktda/Diagnosis/index'
 import FeatureFlags from '../containers/FeatureFlags'
 import CoverLinkSettings from '../containers/CoverLinkSettings'

 import UssdSessions from '../partner-apps/OldMutualMalawi/UssdSessions/index'
 import OmmManagementDashboard from '../partner-apps/OldMutualMalawi/PoliciesDashboard/Management/index'
 import OmkGroupApprovalDashboard from '../partner-apps/OldMutualKenya/GroupApprovalDashboard/index'
 import OmkGroupDetailPage from '../partner-apps/OldMutualKenya/GroupApprovalDashboard/GroupDetailPage'
 import OmkGroupPaymentDashboard from '../partner-apps/OldMutualKenya/GroupPaymentDashboard/index'
 import OmkPaymentDetailPage from '../partner-apps/OldMutualKenya/GroupPaymentDashboard/PaymentDetailPage'
 import PepPoliciesDashboard from '../partner-apps/AccessBank/PoliciesDashboard/PepPoliciesDashboard/index.js'
 import AmendedPoliciesDashboard from '../partner-apps/AccessBank/PoliciesDashboard/AmendedPoliciesDashboard/index.js'
 import PolicyCancellationDashboard from '../partner-apps/Samba/PolicyCancellation/index.js'
 import OldMutualMalawiPolicyCancellationDashboard from '../partner-apps/OldMutualMalawi/PoliciesProcessing/Components/PolicyCancellationDashboard/index.js'

 import PaymentsDashboard from '../partner-apps/AccessBank/PaymentsDashboard/index'
 import PaymentProcessing from '../partner-apps/AccessBank/PaymentProcessing'
 import EmailTemplates from '../containers/EmailTemplates'
 import ReportsConfigs from '../containers/ReportsConfigs'
 import Reports from '../containers/Reports'
 import OrganizationList from '../containers/Organizations/index'
 import OrganizationDetail from '../containers/Organizations/OrganizationDetail'
 import PostHogPageviewTracker from '../PostHogPageviewTracker.js'
import { isPolicyWithSpecialChars } from "../lib/utils.es6.js";
import {
  isCommissionsAgent,
  isAgentAllowedCommissionsPath,
  AGENT_COMMISSIONS_PATH
} from '../lib/commissionsAccess.es6';

import ClaimInitiationMobile from "../shared-ui/MobileCustomerProfileInc/Components/ClaimINitiationMobile/index.js";
import DisplayIPRSFlaggedPolicies from "../partner-apps/AccessBank/PoliciesDashboard/Components/Policies/DisplayIPRSFlaggedPolicies.js";
import AgentPolicies from "../partner-apps/OldMutualKenya/AgentPolicies/index.js";
// import ClaimsProcessingRefactored from "../containers/ClaimsProcessingRefactored/index.js";

// Commissions routes, declared as a table so the seven near-identical route
// entries are not written out seven times. Each `load` is a dynamic import, so
// webpack emits these into the commissions-bundle chunk and the browser only
// fetches it when a Commissions page is opened.
// Collections screens (dashboard, upcoming debits, attempts, holds, runs, debit order detail), loaded on demand.
const collectionsRoutes = [
  { path: 'emple-onboarding', load: () => import('../containers/EmpleOnboarding/index.es6') },
  { path: 'payments-dashboard', load: () => import('../containers/PaymentsDashboard/index.es6') },
  { path: 'collections/dashboard', load: () => import('../containers/Collections/Dashboard.es6') },
  { path: 'collections/upcoming', load: () => import('../containers/Collections/Upcoming.es6') },
  { path: 'collections/my-queue', load: () => import('../containers/Collections/MyQueue.es6') },
  { path: 'collections/team', load: () => import('../containers/Collections/Team.es6') },
  { path: 'collections/at-risk', load: () => import('../containers/Collections/AtRisk.es6') },
  { path: 'collections/attempts', load: () => import('../containers/Collections/Attempts.es6') },
  { path: 'collections/segments', load: () => import('../containers/Collections/Segments.es6') },
  { path: 'collections/holds', load: () => import('../containers/Collections/Holds.es6') },
  { path: 'collections/runs', load: () => import('../containers/Collections/Runs.es6') },
  { path: 'cashback-awards', load: () => import('../containers/CashbackAwards/index.es6') },
  { path: 'collections/order/:guid', load: () => import('../containers/Collections/OrderDetail.es6') },
  // Payment-request transactions (all partners), not debit-order collections.
  { path: 'payments/collections', load: () => import('../containers/PaymentCollections/index.es6') },
  { path: 'refunds', load: () => import('../containers/Refunds/index.es6') },
];

const commissionsRoutes = [
  {
    // The agent's own account — the only commissions route an OMK agent may
    // open (see the allowlist in partner-apps/OldMutualKenya/shared/agentView).
    path: 'commissions/my',
    load: () => import('../containers/AgentCommissions/index.es6'),
  },
  {
    path: 'commissions/agents',
    load: () => import('../containers/CommissionAgents/index.es6'),
  },
  {
    path: 'commissions/agents/:agentGuid',
    load: () => import('../containers/CommissionAgents/AgentView.es6'),
  },
  {
    path: 'commissions/agencies',
    load: () => import('../containers/CommissionAgencies/index.es6'),
  },
  {
    path: 'commissions/agencies/:agencyGuid',
    load: () => import('../containers/CommissionAgencies/AgencyView.es6'),
  },
  {
    path: 'commissions/rules',
    load: () => import('../containers/CommissionRules/index.es6'),
  },
  {
    path: 'commissions/clawback-rules',
    load: () => import('../containers/ClawbackRules/index.es6'),
  },
  {
    path: 'commissions/transactions',
    load: () => import('../containers/CommissionTransactions/index.es6'),
  },
  {
    path: 'commissions/accounts',
    load: () => import('../containers/CommissionAccounts/index.es6'),
  },
  {
    path: 'commissions/batch-payouts',
    load: () => import('../containers/BatchPayouts/index.es6'),
  },
  {
    path: 'commissions/settings',
    load: () => import('../containers/CommissionSettings/index.es6'),
  },
];

// Initialize Google Analyticts
const ANALYTICS_ID = getAnanlyticsId();
ReactGA.initialize(ANALYTICS_ID, 'auto');
function logPageView() {
  ReactGA.set({ page: window.location.hash });
  ReactGA.pageview(window.location.hash);
}

export default (
      // <Suspense fallback={<div>Loading...</div>}>
  <div>
    <Router onUpdate={logPageView} history={hashHistory}>
      {/* Main component will always be rendered */}
      <PostHogPageviewTracker />
      <Route path="/" component={Main}>
        <IndexRoute component={LandingPage} />
        <Route path="drawer" getComponent={(nextState, cb) => {
          import('../components/Drawer/DrawerNew').then(module => cb(null, module.default));
        }} />
        <Route path="login" component={LandingPage} />
        <Route path="admin" getComponent={(nextState, cb) => {
          import('../containers/Admin/index.es6').then(module => cb(null, module.default));
        }}>
          <IndexRoute component={HomePage} />
          <Route path="alerts" component={Alerts} />
          <Route path="policies_dashboard" component={PoliciesDashboard} />
          <Route path="pep_policies_dashboard" component={PepPoliciesDashboard} />
          <Route path="amended_policies_dashboard" component={AmendedPoliciesDashboard} />
          <Route path="iprs_flagged_policies_dashboard" component={DisplayIPRSFlaggedPolicies} />
          <Route path="policy_cancellation" component={PolicyCancellationDashboard} />
          <Route path="policy/cancellations/requests" component={OldMutualMalawiPolicyCancellationDashboard} />
          <Route path="ussd-sessions" component={UssdSessions} />
          <Route path="group-dashboard" component={OmkGroupApprovalDashboard} />
          <Route path="group-detail/:guid" component={OmkGroupDetailPage} />
          <Route path="group-payments-dashboard" component={OmkGroupPaymentDashboard} />
          <Route path="group-payment-detail/:groupGuid/:paymentGuid" component={OmkPaymentDetailPage} />
          <Route path="recent_policies" component={RecentPolicies} />
          <Route path="agent-policies/:view" component={AgentPolicies} />
          <Route path="sales_manager_policies" component={SalesManagerPolicies} />
          <Route path="management_desk" component={OmmManagementDashboard} />
          <Route path="policy_approvals/:stage" component={PolicyApprovalDashboard} />
          <Route path="premium-transfer-approvals" component={PremiumTransferDashboard} />
          <Route path="payments_dashboard" component={PaymentsDashboard} />
          <Route path="recent_payments" component={RecentPaymentsContainer} />
          <Route path="policy/onboard" component={PolicyOnboarding} />
          <Route path="create-quote/:customer_guid" component={PolicyAdmin} />
          <Route path="amend-policy" component={PolicyAmendment} />
          <Route path="amend-policy/:policy_number" component={PolicyAmendment} />
          <Route path="admin-home" component={HomePage} />
          <Route path="register" component={RegisterCustomer} />
          <Route path="knowledge_base" component={KnowledgeBase} />
          <Route path="knowledge_base/:id" component={ViewGuide} />
          <Route path="claim-initiation-mobile/:customer_guid" component={ClaimInitiationMobile} />
          <Route path="claim-initiation-simple/:customer_guid" component={ClaimInitiation} />
          <Route path="cashback" component={Cashback} />
          <Route path="claim-dashboard-v2" component={ClaimDashboardv2} />
          <Route path=  "claim-initiation-complex/:customer_guid"   component={ClaimInitiation} />
          <Route path="claim-processing-v2/:claim_guid" component={ClaimProcessing} />
          <Route path={isPolicyWithSpecialChars() ? "policy-processing/*" : "policy-processing/:policy_number"} component={PolicyProcessing} />
          <Route path="payment-processing/:guid" component={PaymentProcessing} />
          <Route path=  "generate-policy"   component={GeneratePolicy} />
          <Route path="generate-policy/:policy_number" component={GeneratePolicy} />
          <Route path="organizations" component={OrganizationList} />
          <Route path="organizations/:guid" component={OrganizationDetail} />
          <Route path="partners" component={Partners} />
          <Route path="partners/view/partner" component={PartnerStatus} />
          <Route path="customer" component={Customer} />
          <Route path="create-hospital" component={Hospitals} />
          <Route path="create-Diagnosis" component={Diagnosis} />
          <Route path="customer_status/:customer_guid" component={CustomerStatusX} />
          <Route path="bulk-policy-onboarding" component={BulkPolicyOnboarding} />
          <Route path="bulk-payments" component={BulkPayments} />
          <Route path="bulk-policy-onboarding/failed-enteries/:guid" component={FailedEnteries} />
          <Route path="bulk-payments/payment_enteries/:guid" component={FailedPaymentsEnteries} />
          <Route path="generic-products" component={GenericProducts} />
           <Route path="view-generic-product/:productGuid" component={ViewGenericProduct} />
          <Route path="search" component={elasticSearch} />
          <Route path="home" component={HomePage} />
          <Route path="buy_policy" component={BuyPolicy} />
          <Route path="make_claim" component={MakeClaim} />
          <Route path="new-products" component={NewProducts} />
          <Route path="products/view/product/:productGuid" component={ViewProductStatus} />
          <Route path="products" component={NewProducts} />
          <Route path="premiums" component={PremiumList} />
          <Route path="payments" component={PaymentList} />
          <Route path="claims" component={ClaimList} />
          <Route path="policies" component={PolicyList} />
          <Route path="dependants" component={DependantsList} />
          <Route path="profile" component={Profile} />
          <Route path="settings" component={Settings} />
          <Route path="claims_closed" component={ClaimsClosed} />
          <Route path="claims_dashboard" component={ClaimsDashboard} />

          <Route path="Death_claims" component={Death_Claims} />
          <Route path="Disability_Claims" component={Disability_Claims} />
          <Route path="Hospital_claims" component={Hospital_claims} /> 
          <Route path="Last_Expense" component={Last_Expense_claims} />
          <Route path="property_claims" component={property_claims} />
          <Route path="Device_Damage_claims" component={Device_Damage_Claims} />
          <Route path="Device_Theft_claims" component={Device_theft_Claims} />
          <Route path="Funeral_Claims" component={Funeral_Claims} />
          <Route path="Reimbursement_claims" component={Reimbursement_claims} />
          <Route path="Cancer_Claims" component={Cancer_Care_Claims} />
          <Route path="Medical_Cash_Claims" component={Cover_Link_Medical_Cash_Claims} />
          <Route path="legal_claims" component={Cover_Link_Legal_Claims} />
          <Route path="Hospital_Cash_Accident_Claims" component={Hospital_Cash_Accident_Claims} />
          <Route path="critical_Illness_Claims" component={Critical_Illness_Claims} />

          <Route path="claims_payable" component={ClaimsPayable} />
          <Route path="claims_processing/:claim_guid" component={SimpleClaimProcessing} />
          <Route path="claims_open" component={ClaimsOpen} />
          <Route path="claims_status" component={ClaimsStatus} />
          <Route path="claim_callback" component={ClaimCallback} />
          <Route path="users" component={UsersNew} />
          <Route path="partner-users" component={PartnerUsers} />
          <Route path="country" component={ViewCountries} />
          <Route path="languages" component={ViewLanguages} />
          <Route path="missing/payments" component={ManualPayment} />
          <Route path="view_sms_templates" component={SmsTemplate} />
          <Route path="engine-flows" component={EngineFlows} />
          <Route path="kyc-configs" component={KYCConfigs} />
          <Route path="aml-configs" component={AmlConfigs} />
          <Route path="risk-configs" component={RiskConfigs} />
          <Route path="iprs-configs" component={IprsConfigs} />
          <Route path="gateway-configs" component={GatewayConfigs} />
          <Route path="webhook-subscriptions" component={WebhookSubscriptions} />
          <Route path="view_doc_templates" component={DocumentGeneration} />
          <Route path="view_email_templates" component={EmailTemplates} />
          <Route path="view_reports_configs" component={ReportsConfigs} />
          <Route path="reports" component={Reports} />
          <Route path="feature-flags" component={FeatureFlags} />
          <Route path="lookup-settings" component={CoverLinkSettings} />
          {/* Commissions is loaded on demand (see the commissions cacheGroup
              in config-overrides.js) so no other route pays for its weight.
              getComponent is react-router v3's own async pattern, as already
              used for the drawer and admin routes above. */}
          {commissionsRoutes.map(({ path, load }) => (
            <Route
              key={path}
              path={path}
              onEnter={(nextState, replace) => {
                // The menu already hides these from an agent; this closes the
                // typed URL, which is the only way left in.
                if (
                  isCommissionsAgent() &&
                  !isAgentAllowedCommissionsPath(path)
                ) {
                  replace(`/admin/${AGENT_COMMISSIONS_PATH}`)
                }
              }}
              getComponent={(nextState, cb) => {
                load().then(module => cb(null, module.default), err => cb(err))
              }}
            />
          ))}
          {collectionsRoutes.map(({ path, load }) => (
            <Route
              key={path}
              path={path}
              getComponent={(nextState, cb) => {
                load().then(module => cb(null, module.default), err => cb(err))
              }}
            />
          ))}
          <Route path="loyalty_eligibility" component={LoyaltyEligibility} />

          <Route path="dashboards" component={Dashboards} />
          <Route path="bulk_sms" component={BulkSms} />
          <Route path="internal_dashboards" component={InternalDashboards} />

          <Route path="remittances" component={ManualRemittances} />
          <Route path="*" component={PageNotFound} />
        </Route>
        <Route path="*" component={PageNotFound} />
      </Route>
      <Route path="*" component={PageNotFound} />
    </Router>
  </div>
        // </Suspense>
);